import { Island } from '../island.class';
import { IslandType } from '../enums';

import type { PanelThicknessConfig } from '../types';
import type { Size } from '../../../types';

export type SetPanelThicknessConfigCfnParams = {
	config: PanelThicknessConfig | null;
	island: Island;
};

/**
 * Applies a panel thickness config to an island, adjusting island depth/width
 * so panels grow outward. The sizing cfn computes sideWidth = depth - front - back,
 * so increasing depth by the thickness delta keeps side panels at their base width.
 */
export const setPanelThicknessConfigCfn = (params: SetPanelThicknessConfigCfnParams): void => {
	const { config, island } = params;

	if (island.initialized && island.type !== IslandType.Corner) {
		// Capture current thicknesses before config change
		const oldFront = island.getThicknessForRole('front');
		const oldBack = island.getThicknessForRole('back');
		const oldLeft = island.getThicknessForRole('left');
		const oldRight = island.getThicknessForRole('right');

		island.setPanelThicknessData(config);

		const newFront = island.getThicknessForRole('front');
		const newBack = island.getThicknessForRole('back');
		const newLeft = island.getThicknessForRole('left');
		const newRight = island.getThicknessForRole('right');

		// Grow outward: adjust stored size by thickness deltas
		const size = island.size as Size;
		size.depth += (newFront - oldFront) + (newBack - oldBack);
		size.width += (newLeft - oldLeft) + (newRight - oldRight);

		island.size = size;
	} else {
		island.setPanelThicknessData(config);
		if (island.initialized) {
			island.size = island.size;
		}
	}
};
